<template>
  <div class="card">
    <h4 class="margin-t-z margin-b-s">{{ $t('rsvpEdit.custInfo') }}</h4>
    <div class="customer-info">
      <div class="label">{{ $t('rsvpEdit.name') }}:</div>
      <div class="value">{{ customer.firstName }} {{ customer.lastName }}</div>
    </div>
    <div class="customer-info">
      <div class="label">{{ $t('common.email') }}:</div>
      <div class="value">{{ customer.email }}</div>
    </div>
    <div class="customer-info">
      <div class="label">{{ $t('rsvpEdit.phone') }}:</div>
      <div class="value">{{ customer.phones[0].countryCode }}{{ customer.phones[0].phoneNumber }}</div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'customer-info',
  computed: {
    customer () { return this.$store.state.rsvpEdit.editedRsvp.consumer }
  }
}
</script>

<style lang="scss" scoped>
.customer-info {
  position: relative;
  padding: 2px 0;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & .label {
    color: #777;
    width: 130px;
    margin-right: 10px;
    text-align: right;
    font-size: 14px;
  }

  & .value {
    font-size: 16px;
  }
}

.divider {
  display: block;
  height: 0;
  width: 100%;
  border-top: 1px solid rgba(0,0,0,0.2);
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// CustomerInformation.vue?8e8f34d6